<template>
  <div>
    <el-dialog title="自定义显示列" :visible.sync="dialogVisible" width="50%">
      <div class="select-menus menus-box"><p class="menus-title">拖动区块调整显示顺序</p>
        <div class="menus-content">
          <draggable v-model="selected" @update="dataDragEnd" :options="{animation:500}">
            <transition-group>
              <div v-for="menu in selected" :key="menu.key" class="drag-item item">{{ $t(menu.label) }}</div>
            </transition-group>
          </draggable>
        </div>
      </div>
      <div class="menus-container menus-box" v-if="fields.length"><p class="menus-title">选择显示列</p>
        <div class="menus-content">
          <div class="item" :class="{active:!menu.isDetail}" v-for="menu of fields" :key="menu.key"
               @click="onSelect(menu)">{{ $t(menu.label) }}
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clearCustomization">清除设置</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSave">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import draggable from "vuedraggable";

export default {
  name: "EmTableCustomization",
  // inject: ["vuexFieldConfigs", "tableColumns", "localstorageFieldConfigsKey", "tableColumnsReload"],
  props: {types: String,vuexFieldConfigs:{},localstorageFieldConfigsKey:String},
  components: {draggable,},
  data() {
    return {
      dialogVisible: false,
      fields: [],//全部菜单
      selected: [],//已选中菜单
    };
  },
  watch: {
    selected: {
      handler(oldVal, newVal) {
        if (this.fields.length === 0) {
          return;
        }
        newVal.map((i) => {
          this.fields.map((j) => {
            if (i.key === j.key) {
              // 如果已选中数组内已有相同字段， 则isDetail为false。isDetail主要用来控制全部菜单选中/未选中的样式
              j.isDetail = false
            }
          })
        })
      }
    }
  },
  mounted() {
    //为了防止火狐浏览器拖拽的时候以新标签打开
    document.body.ondrop = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };
  },
  methods: {
    getFieldsByVuex() {
      return JSON.parse(JSON.stringify(this.vuexFieldConfigs))
    },
    getFieldsByLocalStore() {
      //把json中的function通过eval转换为function
      return localStorage[this.localstorageFieldConfigsKey] ? JSON.parse(localStorage[this.localstorageFieldConfigsKey], function (key, value) {
        if (typeof value === "string" &&
            value.startsWith("/Function(") &&
            value.endsWith(")/")) {
          value = value.substring(10, value.length - 2);
          return (0, eval)("(" + value + ")");
        }
        return value;
      }) : []
    },
    setFieldsToLocalStore() {
      let object = this.selected
      let abc = JSON.stringify(object, function (key, value) {
        console.log(`key is :${key}`)
        console.log(typeof value)
        if (typeof value === "function") {
          return "/Function(" + value.toString() + ")/";
        }
        return value;
      })
      // let object = {
      //   a: 5,
      //   b:{
      //     ba:"我是ba",
      //   bb: function (param) {
      //     return param;
      //   }
      //   }
      // }
      // let cbd = JSON.stringify(object, function (key, value) {
      //   console.log(`key is :${key}`)
      //   console.log(typeof value)
      //   if (typeof value === "function") {
      //     return "/Function(" + value.toString() + ")/";
      //   }
      //   return value;
      // })
      console.log(abc)
      //把function也保存到json中
      localStorage[this.localstorageFieldConfigsKey] = JSON.stringify(this.selected, function (key, value) {
        if (typeof value === "function") {
          return "/Function(" + value.toString() + ")/";
        }
        return value;
      })
    },
    /**
     * 根据当前选中，重新设置fields的isDetail字段
     */
    markFields() {
      this.fields.map((item) => {
        if (this.selected.some((s => s.key === item.key)))
          item.isDetail = false
        else
          item.isDetail = true
      });
    },
    /**
     * 生成新的selected，1则更新selected中现有字段，2则排除掉fields中没有的字段，还要保证原有selected顺序不变
     * @returns {*[]}
     */
    regenerateSelectedFields() {
      this.selected = this.selected
          .filter(f1 => this.fields.some(f2 => f1.key === f2.key))
          .map(m => this.fields.find(f => f.key === m.key))
    },
    async getData() {
      //获取全部菜单数据
      const {data: fields} = await this.getFieldsByVuex({types: this.types,});
      fields.map((item) => {
        // 由于服务器并没有返回active字段， 为此需要每一条数据增加active字段， 来控制选中的样式
        item.active = false;
      });
      this.fields = fields;
    },
    async getFields() {
      // 获取用户已选中的菜单， 为了再次打开设置时能够把上次选中菜单回显到页面，方便用户再次修改
      let fields = await this.getFieldsByLocalStore({
        account_id: this.$store.state.user.token.account_id,
        userid: this.$store.state.user.token.userid,
        types: this.types,
      });
      this.$nextTick(() => {
        this.selected.push(...fields.data);
      });
    },
    async onSave() {
      // 保存已选中菜单
      await this.setFieldsToLocalStore()
      this.dialogVisible = false
      // this.tableColumnsReload(); //刷新页面
      this.$emit("customizationSave")
    },
    async clearCustomization() {
      // 清空localStorage已选中菜单
      this.selected = []
      localStorage.removeItem(this.localstorageFieldConfigsKey)
      this.dialogVisible = false
      // this.tableColumnsReload(); //刷新页面
      this.$emit("customizationSave")
    },
    async open() {
      // 打开设置窗口时清空数据，并再次请求获取最新数据
      this.fields = this.getFieldsByVuex()
      this.selected = this.getFieldsByLocalStore()
      this.markFields()
      this.regenerateSelectedFields()
      this.dialogVisible = true;
      // await this.getData();
      // await this.getFields();
    },
    onSelect(item) {
      // 判断已选中菜单内是否已有点击选择的菜单
      let findex = this.selected.findIndex((i) => {
        return item.key === i.key;
      });
      if (findex === -1) {
        // 如果已选中菜单内没有, 则添加到最后一条
        this.selected.push(item);
      } else {
        // 如果已选中已有，则点击时应该对其移除，并把active设置为false， 改变其选中的样式
        item.isDetail = true;
        this.selected.splice(findex, 1);
      }
    },
    dataDragEnd(evt) {
      // 拖动排序
      evt.preventDefault();
    },
  },
};
</script>
<style lang="scss" scoped>
/* 全部菜单 */
.menus-container {
  margin-top: 20px;

  .menus-content {
    .item {
      color: #575757;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(220, 220, 220, 1);
      border-radius: 2px 0px 0px 2px;
    }
  }
}

/* 菜单通用样式 */
.menus-box {
  .menus-title {
    margin-top: 10px;
    line-height: 32px;
  }

  .menus-content {
    display: flex;
    flex-wrap: wrap;

    .item {
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 8px;
      margin: 10px;
      border-radius: 3px;
    }

    .active {
      color: #fff;
      background: rgba(72, 153, 229, 1);
      border-radius: 2px 0px 0px 2px;
    }
  }
}

/* 已选菜单 */
.select-menus {
  .menus-content {
    .item {
      margin: 0px;
      border-radius: 0;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(220, 220, 220, 1);
    }
  }
}
</style>